var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.30412 3.3273C4.03439 3.05757 3.59707 3.05757 3.32735 3.3273C3.05762 3.59702 3.05762 4.03434 3.32735 4.30407L9.02324 9.99997L3.3273 15.6959C3.05757 15.9657 3.05757 16.403 3.3273 16.6727C3.59702 16.9424 4.03434 16.9424 4.30407 16.6727L10 10.9767L15.6959 16.6727C15.9657 16.9424 16.403 16.9424 16.6727 16.6727C16.9424 16.403 16.9424 15.9656 16.6727 15.6959L10.9768 9.99997L16.6727 4.30409C16.9424 4.03436 16.9424 3.59705 16.6727 3.32732C16.4029 3.05759 15.9656 3.05759 15.6959 3.32732L10 9.0232L4.30412 3.3273Z",
    fill: "black",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcX);
export default __webpack_public_path__ + "static/media/ic_x.5bc43e171cc4985adda444226099e1be.svg";
export { ForwardRef as ReactComponent };